import {apiCall} from "../../../../common/apiActionHandler";
import axios from "axios";

export const achCheckout = (invoiceToken, amount, callback) => (dispatch, getState) => {
    const config = {
        method: 'post',
        url: `/api/stripe/ach_checkout`,
        data: {token: invoiceToken, amount}
    };

    return apiCall("ACH Checkout", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState, false);
};
